import { JobsConfigurationJob } from "modules/system/sections/plt/field-management/rings/rollout-package/configure/jobs/dtos";

import { newGuid } from "@bps/common-utils";

import { JobDialog, JobDialogProps } from "./JobDialog";
import { JobForm, JobFormValues } from "./JobForm";

interface JobDialogHostProps extends JobDialogProps {
  job?: JobsConfigurationJob;
  onSubmit: (formData: JobFormValues) => void;
}

export const JobDialogHost: React.FC<JobDialogHostProps> = ({
  job,
  modeLabel,
  onSubmit,
  onDismiss,
  ...props
}) => {
  const submit = async (formData: JobFormValues) => {
    onSubmit(formData);
    onDismiss?.();
  };

  const initialValues =
    job ??
    ({
      id: newGuid()
    } as JobsConfigurationJob);

  return (
    <JobDialog modeLabel={modeLabel} onDismiss={onDismiss} {...props}>
      <JobForm
        initialValues={initialValues}
        onSubmit={submit}
        onDismiss={() => onDismiss?.()}
      />
    </JobDialog>
  );
};
